<div class="container-fluid">


    <div class="row" id="formpage">
        <div class="col-md-7">


            <div id="imgcontainer">

                <img class="loginimg" src="assets/images/loginimg.png" />
            </div>

        </div>
        <div class="col-md-5">
            <mat-card class="loginForm">
                <mat-card-content>
                    <form class="example-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <mat-form-field class="example-full-width col-md-12">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email">


                            </mat-form-field>

                            <div class="text-danger col-md-12"
                                *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].touched">
                                Please enter valid email address
                            </div>

                            <mat-form-field class="example-full-width col-md-12">
                                <input type="password" matInput placeholder="Password" formControlName="pwd">
                            </mat-form-field>

                            <div class="text-danger col-md-12"
                                *ngIf="loginForm.controls['pwd'].invalid && loginForm.controls['pwd'].touched">
                                Please enter password
                            </div>
                            <div id="emailpass">
                                Please enter valid email address and password
                            </div>
                        </div>
                        <div class="row login">
                            <button [disabled]="!loginForm.valid" id="loginnew" class="col-md-6" type="submit"
                                mat-raised-button color="primary">Login</button>
                            <div class="col-md-6 mt-2">
                                <a class="forgot-password" [routerLink]="['forgotpassword']" class="clickablelink forgotPass">Forgot
                                    Password</a>
                            </div>
                        </div>

                        <div class="row register">
                            <button [routerLink]="['/register']" id="register" class="col-md-6" type="button"
                                mat-raised-button color="primary">Register New Account</button>

                        </div>



                    </form>

                </mat-card-content>
            </mat-card>

            <div id="educatetext">

                <img class="loginimgsnk" src="assets/images/loginsnk.png" />
            </div>
        </div>
    </div>


</div>